export const showEqualWebDrawer = (): void => {
  const element = document.getElementById('INDmenu-btn');
  if (element) element.click();
};
